const INTEGER_NUMBER_FORMAT = "#,##0";
const DECIMAL_NUMBER_FORMAT = "#,##0.00";

export const getNumberFormat = (value) =>
  Number.isInteger(Number(value))
    ? INTEGER_NUMBER_FORMAT
    : DECIMAL_NUMBER_FORMAT;

const getFormattedNumberDisplay = (value) =>
  Number(value).toLocaleString("en-US", {
    minimumFractionDigits: Number.isInteger(Number(value)) ? 0 : 2,
    maximumFractionDigits: Number.isInteger(Number(value)) ? 0 : 2,
  });

export const applyThousandsFormat = (cell) => {
  if (typeof cell === "number") {
    return {
      v: cell,
      m: getFormattedNumberDisplay(cell),
      ct: { fa: getNumberFormat(cell), t: "n" },
    };
  }

  if (!cell || typeof cell !== "object" || typeof cell.v !== "number") {
    return cell;
  }

  return {
    ...cell,
    ct: {
      ...cell.ct,
      fa: getNumberFormat(cell.v),
      t: "n",
    },
    // Fortune Sheet renders preloaded formatted numbers from `m`. Keeping only
    // `v` makes the value appear blank after the workbook is reopened.
    m: getFormattedNumberDisplay(cell.v),
  };
};
